import { Component, inject } from '@angular/core';
import { ListService } from '@abp/ng.core';
import { CardBodyComponent, CardComponent, ConfirmationService } from '@abp/ng.theme.shared';
import { Column } from 'angular-slickgrid';
import { BaseCrudComponent, CrudPage, FieldMapperHelper, ICrudService } from '@zendra/shared';
import {
  GetGisProtectedAreaInconsistenciesInputDto,
  GisProtectedAreaInconsistencyExcelDownloadDto,
  GisProtectedAreaInconsistencyDto,
  GisProtectedAreaInconsistencyPlanningOrchestratorService,
} from 'orchestrator';
import { Observable, throwError } from 'rxjs';
import {
  GISPROTECTEDAREAINCONSISTENCYONLYINZENDRA_CONFIG,
  GISPROTECTEDAREAINCONSISTENCYONLYINZENDRA_FIELDS,
} from './gis-protected-area-inconsistency-only-in-zendra.config';

type GisProtectedAreaInconsistencyRow = GisProtectedAreaInconsistencyDto;
type UnsupportedCrudDto = Record<string, never>;

@Component({
  selector: 'lib-gis-protected-area-inconsistency-only-in-zendra',
  imports: [CardComponent, CardBodyComponent, CrudPage],
  providers: [ListService, ConfirmationService],
  templateUrl: '../gis-stand-inconsistency/gis-stand-inconsistency.html',
})
export class GisProtectedAreaInconsistencyOnlyInZendra extends BaseCrudComponent<
  GisProtectedAreaInconsistencyRow,
  UnsupportedCrudDto,
  UnsupportedCrudDto,
  GisProtectedAreaInconsistencyExcelDownloadDto
> {
  private readonly snapshotService = inject(GisProtectedAreaInconsistencyPlanningOrchestratorService);
  private cachedColumns: Column[] | null = null;

  config = GISPROTECTEDAREAINCONSISTENCYONLYINZENDRA_CONFIG;
  fields = GISPROTECTEDAREAINCONSISTENCYONLYINZENDRA_FIELDS;

  get columns(): Column[] {
    this.cachedColumns ??= FieldMapperHelper.buildColumnsFromFields(
      this.fields,
      this.localizationService,
      this.injector,
    );
    return this.cachedColumns;
  }

  service: ICrudService<
    GisProtectedAreaInconsistencyRow,
    UnsupportedCrudDto,
    UnsupportedCrudDto,
    GisProtectedAreaInconsistencyExcelDownloadDto
  > = {
    create: () => this.unsupportedCrudOperation('create'),
    update: () => this.unsupportedCrudOperation('update'),
    deleteByIds: () => this.unsupportedCrudOperation('delete'),
    getList: query =>
      this.snapshotService.getOnlyInZendra({ ...query, sorting: query?.sorting || 'Id desc' } as GetGisProtectedAreaInconsistenciesInputDto),
    getDownloadToken: () => this.snapshotService.getDownloadToken(),
    getListAsExcelFile: input => {
      const fields = input.fields as string[] | string | undefined;
      return this.snapshotService.getOnlyInZendraAsExcelFile({
        ...input,
        fields: typeof fields === 'string' ? fields.split(',').filter(Boolean) : fields,
        sorting: input.sorting || 'Id desc',
      });
    },
  };

  protected prepareUpdateDto(): UnsupportedCrudDto {
    return {};
  }

  protected getEntityName(): string {
    return 'GisProtectedAreaInconsistencyOnlyInZendra';
  }

  private unsupportedCrudOperation<T>(operation: string): Observable<T> {
    return throwError(() => new Error(`GIS protected area inconsistencies are read-only; ${operation} is not supported.`));
  }
}
